module.exports = __webpack_public_path__ + "img/munus-logo_v2.49482f1f.png";